import { UserStateModel } from 'models/UserState';
import { User } from "models/User"

//type Visibility = "all" | "completed" | "active";

export type UserAction =
  | { type: "set_user"; user: User }
  | { type: "update_user"; user: User }
  | { type: "remove_user"; phonenumber: string };

export const userReducer = (state: UserStateModel, action: UserAction) : UserStateModel => {
    switch (action.type)
    {
      case 'set_user':
        return {...state, user: action.user};
      case 'update_user' :
        {
          return {...state, user: action.user};
        }
      default:
        return state;
    }
};